import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';

@Component({
    template: ''
})
export abstract class AbstractComponent implements OnDestroy, OnInit {
    public subscriptions$: Subscription = new Subscription();

    public ngOnInit(): void {}

    public ngOnDestroy(): void {
        this.subscriptions$.unsubscribe();
    }
}
